export default String.raw`
{% assign address = include -%}

{% assign cartAddress = cart.Customer.DeliveryAddress -%}
{% assign checkInput = false -%}

{% assign addressName = address.Name | H -%}
{% assign addressName2 = address.Name2 | H -%}
{% assign addressName3 = address.Name3 | H -%}
{% assign addressStreet = address.Street | H -%}
{% assign addressStreetNo = address.StreetNo | H -%}
{% assign addressUnitNo = address.UnitNo | H -%}
{% assign addressZipCode = address.ZipCode | H -%}
{% assign addressCity = address.City | H -%}
{% assign addressState = address.State | H -%}
{% assign addressCountry = address.Country | H -%}
{% assign addressPhoneNo = address.PhoneNo | H -%}
{% assign cartAddressName = cartAddress.Name | H -%}
{% assign cartAddressName2 = cartAddress.Name2 | H -%}
{% assign cartAddressName3 = cartAddress.Name3 | H -%}
{% assign cartAddressStreet = cartAddress.Street | H -%}
{% assign cartAddressStreetNo = cartAddress.StreetNo | H -%}
{% assign cartAddressUnitNo = cartAddress.UnitNo | H -%}
{% assign cartAddressZipCode = cartAddress.ZipCode | H -%}
{% assign cartAddressCity = cartAddress.City | H -%}
{% assign cartAddressState = cartAddress.State | H -%}
{% assign cartAddressCountry = cartAddress.Country | H -%}
{% assign cartAddressPhoneNo = cartAddress.PhoneNo | H -%}

{% unless selectedAddress -%}
    {% if addressName == cartAddressName and addressName2 == cartAddressName2 and addressName3 == cartAddressName3 and addressStreet == cartAddressStreet and addressStreetNo == cartAddressStreetNo and addressUnitNo == cartAddressUnitNo and addressZipCode == cartAddressZipCode and addressCity == cartAddressCity and addressState == cartAddressState and addressCountry == cartAddressCountry and addressPhoneNo == cartAddressPhoneNo -%}
            {% assign selectedAddress = true -%}
            {% assign checkInput = true -%}
    {% endif -%}
{% endunless -%}

<div class="cart-addresses-list__item address-option-js">
    {% unless cart.SelectedDelivery.PhoneRequired and address.PhoneNo == '' -%}
        <label tabindex="0" role="radio" aria-checked={% if address.Default -%}"true"{% else -%}"false"{% endif -%} class="cart-addresses-list__item-label">
            <input class="cart__radio" type="radio" name="id" value="{{address.Id}}" {% if checkInput -%} checked {% endif -%} >
            <div class="cart__radio-box cart-addresses-list__item-radio"></div>
    {% endunless -%}
            <div class="cart-addresses-list__item-columns">
                <div>
                    <div class="cart-addresses-list__item-title">
                        <span data-name="name">{{address.Name | H}}</span>
                        {% if address.Name2 != '' -%}
                            <br>
                            <span data-name="name2">{{address.Name2 | H}}</span>
                        {% endif -%}
                    </div>
                    <div class="cart-addresses-list__item-text">
                        <div>
                            <span data-name="street">{{address.Street | H}}</span>
                            <span data-name="streetNo">{{address.StreetNo}}</span>{% if address.UnitNo != ''-%}/<span data-name="unitNo">{{address.UnitNo}}</span> {% endif -%}
                        </div>
                        
                        {% if address.PhoneNo != '' -%}
                            <div>
                                <span data-name="phoneNo">{{address.PhoneNo}}</span>
                            </div>
                        {% endif -%}
                    </div>
                    <div class="cart-addresses-list__item-text">
                        <div>
                            <span data-name="zipCode"> {{address.ZipCode}}</span> <span data-name="city">{{address.City}}</span>
                        </div>
                        <div>
                            <span data-name="email">{{cart.Customer.Email}}</span>
                        </div>
                    </div>
                    {% assign selectedCountry = "" -%}
                    {% for country in config.Countries -%}
                        {% if country.ISOCode == cart.Customer.DeliveryAddress.Country -%}
                            {% assign selectedCountry = country -%}
                            {% break -%}
                        {% endif -%} 
                    {% endfor -%}
                    <div class="cart-addresses-list__item-text">
                        <div>
                            <span data-name="state">{{address.State}}</span> <span data-name="countryCode" data-selected-country="{{ selectedCountry.ISOCode }}" data-country="{{ config.Countries[address.Country].ISOCode }}">{{config.Countries[address.Country].Name}}</span>
                        </div>
                    </div>
                </div>
            </div>
    {% unless cart.SelectedDelivery.PhoneRequired and address.PhoneNo == '' -%}
        </label>
    {% endunless -%}
    <div class="cart-addresses-list__item-edit">
        <button class="cart__action-btn cart-edit-customer-address-js" data-id="{{address.Id}}" data-default="{{address.Default}}">{{ translations.Edit }}</button>
        {% if address.Default -%}
            <div class="cart-addresses-list__item-default">
                {{ translations.DefaultAddress }}
            </div>                
        {% endif -%}
    </div>
</div>
`